module.exports = __webpack_public_path__ + "assets/img/icon.936e5970.png";